/* eslint-disable max-len */
import React from 'react';

interface TriangleIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const TriangleIcon: React.FC<TriangleIconProps> = ({ color, ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.56421 2.77473C9.75536 2.43491 10.2446 2.43491 10.4358 2.77473L18.5809 17.2549C18.7683 17.5882 18.5275 18 18.1451 18H1.85492C1.47251 18 1.23165 17.5882 1.41914 17.2549L9.56421 2.77473Z"
      fill={color ?? props?.style?.color}
    />
  </svg>
);

export default TriangleIcon;
